import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivateFn, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { RoomSettingsContainerComponent } from '@rocksoft/places';

@Injectable()
export class RoomSettingsDeactivateGuard {
  private readonly router = inject(Router);

  canDeactivate: CanDeactivateFn<RoomSettingsContainerComponent> = (
    component: RoomSettingsContainerComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ) => {
    if (!nextState) {
      return false;
    }

    const currentTree = this.router.parseUrl(currentState.url);
    const nextTree = this.router.parseUrl(nextState.url);
    const currentSegments = currentTree.root.children.primary?.segments ?? [];
    const nextSegments = nextTree.root.children.primary?.segments ?? [];

    const isRoomRoute = (segments: UrlSegment[]) => segments.some((segment) => segment.path === 'rooms');

    const tailAfterRoom = (segments: UrlSegment[]) => {
      const i = segments.findIndex((s) => s.path === 'rooms');
      if (i < 0 || i + 1 >= segments.length) return [];
      return segments.slice(i + 2).map((s) => s.path); // everything after roomId
    };

    const currentTail = tailAfterRoom(currentSegments);
    const nextTail = tailAfterRoom(nextSegments);

    if (isRoomRoute(currentSegments) && isRoomRoute(nextSegments) && currentTail.length > 0 && nextTail.length === 0) {
      void this.router.navigate([...nextSegments.map((s) => s.path), ...currentTail], {
        queryParams: nextTree.queryParams,
        // Preserve incoming URL hash (e.g. external deep links), even when we reconstruct the path.
        fragment: nextTree.fragment ?? undefined,
      });
    }
    return true;
  };
}
